import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const GridView = () => import('./pages');

const moduleRoute = {
  path: '/grid-view',
  name: 'GridView',
  component: GridView,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.WORK_CENTERS_GRIDS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
